// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import theme variables */

/* Reset and Base Styles */
* {
    box-sizing: border-box;
}

body {
    background-color: var(--bg-primary);
    color: var(--text-primary);
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.3s ease, color 0.3s ease;
}

/* Typography */
h1 {
    color: var(--text-primary);
    font-size: 48px;
    font-weight: 700;
    margin: 24px 0;
    line-height: 1.2;
}

h2 {
    color: var(--text-primary);
    font-size: 32px;
    font-weight: 600;
    margin: 20px 0;
    line-height: 1.3;
}

h3 {
    color: var(--text-primary);
    font-size: 24px;
    font-weight: 500;
    margin: 16px 0;
    line-height: 1.4;
}

h4 {
    color: var(--text-primary);
    font-size: 20px;
    font-weight: 500;
    margin: 12px 0;
    line-height: 1.5;
}

p {
    color: var(--text-secondary);
    font-size: 16px;
    line-height: 1.6;
    margin: 12px 0;
}

/* Utility Classes */
.textGray {
    color: var(--text-tertiary);
}

.textLight {
    color: var(--text-secondary);
}

.textWhite {
    color: var(--text-primary);
}

/* Page Title */
.pageTitle {
    text-align: center;
    margin: 32px 0 24px;
}

/* Responsive Typography */
@media (max-width: 768px) {
    h1 {
        font-size: 36px;
    }

    h2 {
        font-size: 28px;
    }

    h3 {
        font-size: 20px;
    }
}

@media (max-width: 480px) {
    h1 {
        font-size: 28px;
    }

    h2 {
        font-size: 24px;
    }

    h3 {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAG3B,0BAA0B;AAC1B;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,uDAAuD;AAC3D;;AAEA,eAAe;AACf;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Import theme variables */\n@import './theme.css';\n\n/* Reset and Base Styles */\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: var(--bg-primary);\n    color: var(--text-primary);\n    margin: 0;\n    padding: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Typography */\nh1 {\n    color: var(--text-primary);\n    font-size: 48px;\n    font-weight: 700;\n    margin: 24px 0;\n    line-height: 1.2;\n}\n\nh2 {\n    color: var(--text-primary);\n    font-size: 32px;\n    font-weight: 600;\n    margin: 20px 0;\n    line-height: 1.3;\n}\n\nh3 {\n    color: var(--text-primary);\n    font-size: 24px;\n    font-weight: 500;\n    margin: 16px 0;\n    line-height: 1.4;\n}\n\nh4 {\n    color: var(--text-primary);\n    font-size: 20px;\n    font-weight: 500;\n    margin: 12px 0;\n    line-height: 1.5;\n}\n\np {\n    color: var(--text-secondary);\n    font-size: 16px;\n    line-height: 1.6;\n    margin: 12px 0;\n}\n\n/* Utility Classes */\n.textGray {\n    color: var(--text-tertiary);\n}\n\n.textLight {\n    color: var(--text-secondary);\n}\n\n.textWhite {\n    color: var(--text-primary);\n}\n\n/* Page Title */\n.pageTitle {\n    text-align: center;\n    margin: 32px 0 24px;\n}\n\n/* Responsive Typography */\n@media (max-width: 768px) {\n    h1 {\n        font-size: 36px;\n    }\n\n    h2 {\n        font-size: 28px;\n    }\n\n    h3 {\n        font-size: 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    h1 {\n        font-size: 28px;\n    }\n\n    h2 {\n        font-size: 24px;\n    }\n\n    h3 {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
